<mat-form-field appearance="outline" [formGroup]="formulario" [ngClass]="classe">
  <mat-label>{{descricao}}</mat-label>
  <input class="text-left"
    matInput
    [type]="tipo"
    [attr.inputmode]="modoInsercao"
    [formControlName]="nomeControle"
    [autocomplete]="autoPreenchimento"
    [id]="identificacao"
    (change)="change()"
    [matAutocomplete]="auto"
    />

    <mat-autocomplete #auto="matAutocomplete" panelWidth="85vw" [displayWith]="displayCategoria">
      <!-- Exibe as opções limitadas ou todas -->
      <mat-option *ngFor="let option of opcoesParaExibir" [value]="option">
        <strong>{{option.descricao}}</strong> em {{option.caminho}}
      </mat-option>

      <!-- Botão Ver Mais/Ver Menos -->
      <mat-option *ngIf="mostrarBotaoVerMais" [value]="null" disabled class="opcao-ver-mais">
        <button
          mat-button
          color="primary"
          (click)="toggleVerMais($event)"
          class="btn-ver-mais">
          {{mostrandoTodas ? ('ver_menos' | transloco) : ('ver_mais_normal' | transloco)}}
          ({{totalOpcoesFiltradas}} opções)
        </button>
      </mat-option>
    </mat-autocomplete>

  <mat-hint>{{textoAjuda}}</mat-hint>
</mat-form-field>
